import { render, staticRenderFns } from "./ValidationGroup.vue?vue&type=template&id=29c20515"
import script from "./ValidationGroup.vue?vue&type=script&lang=ts"
export * from "./ValidationGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports